<template>
  <div>
    <el-form :model="enterpriseInfo" :rules="rules" ref="enterpriseInfo" label-position="top">
      <el-form-item label="团队名称" prop="enterpriseName">
        <el-input v-model="enterpriseInfo.enterpriseName" @input="generateAcronym"></el-input>
      </el-form-item>

      <el-alert title="注意：团队名称只可以修改一次，请谨慎操作！" type="info" show-icon :closable="false" />

      <el-form-item label="团队编码" prop="enterpriseCode">
        <Input v-model="enterpriseInfo.enterpriseCode" class="inputStyle"
               placeholder="团队编码" size="large" />
      </el-form-item>

      <el-form-item label="详细地址" prop="address">
        <el-input v-model="enterpriseInfo.address"></el-input>
      </el-form-item>

      <el-form-item label="电话号码" prop="phoneNumber">
        <el-input v-model="enterpriseInfo.phoneNumber"></el-input>
      </el-form-item>
    </el-form>

    <el-button type="primary" style="margin-top:10px;" @click="confirmSubmit">更新基本信息</el-button>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  computed: {
    ...mapGetters(["currentEnterprise"])
  },

  watch: {
    currentEnterprise: {
      immediate: true,
      deep: true,
      handler(newValue, oldValue) {
        this.enterpriseInfo = {
          enterpriseName: newValue.enterpriseName,
          enterpriseCode: newValue.enterpriseCode,
          address: newValue.address,
          phoneNumber: newValue.phoneNumber,
          id: newValue.id
        };
        this.originalEnterpriseInfo = this.$js.deepClone(this.enterpriseInfo);
      }
    }
  },

  data() {
    return {
      enterpriseInfo: null,
      originalEnterpriseInfo: null,
      rules: {
        enterpriseName: [
          {
            required: true,
            message: "团队名字不能为空！",
            trigger: "blur"
          }
        ],
        address: [
          {
            required: true,
            message: "详细地址不能为空！",
            trigger: "blur"
          }
        ],
        phoneNumber: [
          {
            required: true,
            message: "电话号码不能为空！",
            trigger: "blur"
          }
        ]
      }
    };
  },
  methods: {
    confirmSubmit() {
      if (
        this.$js.deepEqual(this.enterpriseInfo, this.originalEnterpriseInfo)
      ) {
        this.$message.warning("数据未发生任何修改！");
        return;
      }
      this.$refs.enterpriseInfo.validate(valid => {
        if (valid) {
          this.submitEnterpriseInfo();
        } else {
          return false;
        }
      });
    },

    submitEnterpriseInfo() {
      this.$api
        .updateEnterpriseInfo(this.enterpriseInfo)
        .then(() => {
          this.$message.success("更新成功");
          this.$store.dispatch("users/getUserEnterprise");
        })
        .catch(() => {
          this.enterpriseInfo = this.$js.deepClone(this.originalEnterpriseInfo);
        });
    },

    generateAcronym() {
      this.enterpriseInfo.enterpriseCode = this.$js.pinyin.getCamelChars(this.enterpriseInfo.enterpriseName);
    }
  }
};
</script>

<style scoped lang="scss">
::v-deep .el-form-item__label {
  font-weight: bold;
  color: #606266;
  font-size: 14px;
  padding-bottom: 0;
}
</style>
